<template lang='pug'>
  .rsv-dtls.container.component
    rsv-stamp(
      v-if='rsv.status == "Canceled"'
      :text='$t("CANCELED")'
    )
    table
      thead
        tr.biz-name(v-if='options.show.biz')
          th {{ $t('Business Name') }}
          td(:class='{emphasize: options.show.biz, enlarge: options.show.biz}') {{ business.name || 'Not Entered' }}
        tr.biz-name(v-if='options.show.biz')
          th {{ $t('Business Email')}}
          td {{ business.email}}
        tr.biz-name(v-if='options.show.biz')
          th {{ $t('Business Phone')}}
          td {{ business.phone}}
        tr.cus-name(v-if='options.show.cus')
          th {{ $t('Customer Name') }}
          td  {{ customer.username}}
        tr(v-if='options.show.cus')
          th {{ $t('Customer Email') }}
          td {{ customer.email }}
        tr(v-if='options.show.cus')
          th {{ $t('Customer Phone') }}
          td {{ customer.phone}}
        tr( v-if='rsv.class != "custom"' )
          th {{ $t('Service') }}
          td.emphasize {{ service.title }}
        tr( v-if='rsv.class != "custom"' )
          th {{ $t('Price') }}
          td ${{ service.price }}
        tr
          th {{ $t('Date') }}
          td.emphasize.enlarge {{ rsv.datetime.start.toDate().toLocaleDateString() }}
        tr
          th {{ $t('Reserved Time') }}
          td.emphasize.enlarge {{ rsv.datetime.start.toDate().toLocaleTimeString([], {hour: 'numeric', minute:'2-digit'}) }}
        tr( v-if='rsv.class != "custom"' )
          th {{ $t('Appointment Time') }}
          td {{ service.duration }} {{ $t('mins') }}
        tr
          th {{ $t('Customer Comments') }}
          td {{ rsv.message }} 
</template>

<script>
  import { db } from '@/main'

  export default {
    name: 'rsv-dtls.component',

    props: {
      rsv: { type: Object, default: () => ({}) },
      options: { type: Object, default: () => ({ show: { biz: false, cus: true } })}
    },

    data() {
      return {
        business: {},
        customer: {},
        service: {}
      }
    },

    firestore() {
      return {
        business: db.collection('businesses').doc( this.rsv.business_id ),
        customer: db.collection('accounts').doc( this.rsv.account_id ),
        service: db.collection('services').doc( this.rsv.service_id )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .rsv-dtls
    //
    margin-top 0px
  table
    overflow hidden
    width 100%
    text-align left
    font-size 1.02em
    box-sizing border-box
    border-radius 5px
    th, td
      padding 12px 16px
    th
      background rgba( 0 75 150 .1 )
      text-align right
      width 150px
      font-weight bold
    tr:nth-child(odd)
      background rgba( 0 0 0 .05 )
    .emphasize
      font-weight bold

  .rsv-dtls.overlay
    .biz-name
      // display none
    .cus-name
      // display table-row
</style>
